module.exports = __webpack_public_path__ + "logov2.png?906000687f75ef82df2097a83c6a8712";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logov2.png
// module id = 15
// module chunks = 0